import React, { useEffect } from "react";

import Input from "../../forms/Input";
import Headline from "../../Headline";
import LoadingIndicator from "../../LoadingIndicator";
import Margin from "../../Margin";
import Button from "../../NewForms/Button";
import { UncontrolledNotification as Notification } from "../../Notification";
import useStore from "./store";

const ContactForm = ({ endpoint, id, headline, buttonLabel, items }) => {
    const {
        initialize,
        formData,
        onChange,
        dataIsValid,
        hasErrorAt,
        sending,
        sendingError,
        emailSent,
        setSending,
        setEmailSent,
        setSendingError,
    } = useStore();

    useEffect(() => {
        initialize(id, items);
    }, [id, items, initialize]);

    const onSubmit = (event) => {
        event.preventDefault();

        if (dataIsValid()) {
            setSending(true);

            // Do some stuff
            setTimeout(() => {
                setSending(false);
                setEmailSent(true);
                setSendingError(false);
            }, 2000);
        }
    };

    if (sendingError) {
        return (
            <>
                <Headline>Entschulding</Headline>
                <div>
                    Es ist leider ein Fehler aufgetreten. Versuchen Sie es bitte
                    erneut.
                </div>
                <Margin
                    Component={Button}
                    top="10"
                    fullWidth
                    onClick={() => setSendingError(false)}
                >
                    Zum Formular
                </Margin>
            </>
        );
    }

    if (sending) {
        return (
            <Notification>
                <LoadingIndicator>
                    Deine Nachricht wird übermittelt. Habe bitte einen Moment
                    Geduld.
                </LoadingIndicator>
            </Notification>
        );
    }

    if (emailSent) {
        return (
            <Notification>
                <Headline>Vielen Dank für Ihre Anfrage</Headline>
                <div>
                    Wir haben Ihre Anfrage erhalten und melden uns in Kürze bei
                    Ihnen.
                </div>
            </Notification>
        );
    }

    return (
        <div>
            <Headline>{headline}</Headline>
            <form
                method="post"
                action={`/${endpoint}`}
                id={id}
                onSubmit={onSubmit}
            >
                {Object.keys(formData).map((name, key) => (
                    <Input
                        key={key}
                        type="text"
                        name={formData[name].name}
                        placeholder={formData[name].placeholder}
                        required={formData[name].required}
                        validation={formData[name].validation}
                        value={formData[name].value}
                        onChange={onChange}
                        forceError={hasErrorAt(name)}
                    />
                ))}
                <Button color="red">{buttonLabel}</Button>
            </form>
        </div>
    );
};

export default ContactForm;
